import {
  Box,
  ListItem,
  ListItemButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material"
import { IOrderBump } from "../../../../../core/types/OrderBump"
import numbers from "../../../../../core/functions/NumberFunctions"
import React from "react"
import { TPaymentMethodEnum } from "../../../../../core/types/Product"
import { EditableTypography } from "../../../../Typographys/EditableTypography"
import BpCheckbox from "../../../../Inputs/BpCheckboxGreen"

interface ICheckoutOrderBump6Prop {
  paymentInstallment: number
  paymentMethodType: number
  orderBump: IOrderBump
  onChange(orderBump: IOrderBump): void
}

const CheckoutOrderBump6 = ({
  paymentInstallment,
  paymentMethodType,
  orderBump,
  onChange,
}: ICheckoutOrderBump6Prop): JSX.Element => {
  const paymentsAccept = [
    TPaymentMethodEnum.CreditCard,
    TPaymentMethodEnum.TwoCreditCard,
    TPaymentMethodEnum.CreditCardAndPix,
  ]

  const containsInstallments =
    orderBump.installments && orderBump.installments.length > 0

  const isInstallments =
    paymentsAccept.includes(paymentMethodType) &&
    containsInstallments &&
    paymentInstallment > 1

  const value =
    orderBump.productPrice?.firstPurchasePrice ?? orderBump.productPrice?.value

  const installmentValue = isInstallments
    ? orderBump.installments?.find(
        (o) => o.installmentNumber === paymentInstallment
      )?.value
    : null

  const orderBumpValue = installmentValue ?? value

  const handleClick = () => {
    orderBump.selected = !orderBump.selected
    onChange(orderBump)
  }

  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down("md")
  )

  return (
    <>
      <ListItem key={`ob-${orderBump.id}`} disablePadding>
        <ListItemButton
          dense
          role={undefined}
          className="listItemButtonOrderBump"
          onClick={handleClick}
          sx={{
            padding: "0px",
            borderRadius: "10px",
            mb: 2,
          }}
        >
          <Stack direction={"column"} width="100%">
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#D3F3DB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                borderRadius: "10px 10px 0px 0px",
                border: "2px dotted #364E9D",
                borderBottom: "0px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              padding={1}
            >
              <Stack
                width="100%"
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
                sx={{ pr: 1 }}
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <Box>
                    <BpCheckbox checked={orderBump.selected ?? false} />
                  </Box>
                  <Typography
                    variant="h5"
                    fontWeight={500}
                    fontFamily="Montserrat"
                    fontSize="14px"
                    lineHeight="14px"
                    color="#22A744"
                  >
                    {orderBump.title}
                  </Typography>
                </Stack>
                <Typography
                  variant="h5"
                  fontWeight={500}
                  fontFamily="Montserrat"
                  fontSize="14px"
                  lineHeight="14px"
                  color="#22A744"
                >
                  {numbers.formatMoneyDefault(orderBumpValue)}
                </Typography>
              </Stack>
            </Box>

            <Stack
              sx={{
                border: "2px dotted #364E9D",
                borderTop: "0px",
                backgroundColor: "white",
                borderRadius: "0px 0px 10px 10px",
              }}
            >
              <Box p={{ xs: 1, sm: 2 }}>
                <Box
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    gap: "8px",
                    borderRadius: "10px",
                  }}
                >
                  <Box width="100%" sx={{ flexGrow: 1, display: "flex" }}>
                    <Box width="100%">
                      <Stack
                        direction={"row"}
                        sx={{ width: "100%", pl: { xs: 0, sm: 1 }, pr: 1 }}
                        alignItems="center"
                        gap="12px"
                      >
                        <Box
                          sx={{
                            borderRadius: "8px",
                            mt: 1,
                          }}
                        >
                          {orderBump.productPrice?.product?.coverUrl &&
                            orderBump.productPrice?.product?.coverUrl !==
                              "" && (
                              <img
                                src={
                                  !orderBump.productPrice?.product?.coverUrl
                                    ? `${process.env.PUBLIC_URL}/top.png`
                                    : orderBump.productPrice.product.coverUrl
                                }
                                alt={orderBump.productPrice?.product?.name}
                                style={{
                                  height: isSmallScreen ? 80 : 90,
                                  width: isSmallScreen ? 80 : 90,
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                              />
                            )}
                        </Box>
                        <Stack
                          direction={"column"}
                          spacing={1}
                          sx={{ flexGrow: 1, width: "100%" }}
                        >
                          <Typography
                            variant="h5"
                            fontFamily="Montserrat"
                            fontSize="12px"
                            lineHeight="20px"
                            fontWeight={400}
                            color="rgba(56, 57, 59, 1)"
                          >
                            <EditableTypography
                              htmlContent={orderBump.description ?? ""}
                            />
                          </Typography>
                        </Stack>
                      </Stack>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Stack>
          </Stack>
        </ListItemButton>
      </ListItem>
    </>
  )
}

export default CheckoutOrderBump6
